module.exports = __webpack_public_path__ + "assets/pin_restaurant-5be83d.svg";